import { formatDate, parseRecipientPreview } from './emailUtils';

function EmailGroups({
  groupForm,
  groups,
  onCreate,
  onDelete,
  onRemoveEmail,
  onSelect,
  onUpdateForm,
  selectedGroup,
  submitting,
}) {
  const preview = parseRecipientPreview(groupForm.emailsText);
  const selectedEmailsText = selectedGroup?.emails?.map((record) => record.email).join('\n') || '';

  return (
    <div className="admin-email-groups-layout">
      <aside className="admin-panel admin-email-group-list">
        <div className="admin-page__header--split">
          <h2>Groups</h2>
          <span className="admin-email-badge">{groups.length}</span>
        </div>
        {groups.map((group) => (
          <button
            className={selectedGroup?._id === group._id ? 'is-active' : ''}
            key={group._id}
            onClick={() => onSelect(group)}
            type="button"
          >
            <strong>{group.name}</strong>
            <span>{group.emails?.length || 0} emails</span>
            <span>{formatDate(group.updatedAt || group.createdAt)}</span>
          </button>
        ))}
        {groups.length === 0 ? <p className="admin-empty">No groups yet.</p> : null}
      </aside>

      <section className="admin-panel admin-email-group-editor">
        <form onSubmit={onCreate}>
          <div className="admin-page__header--split">
            <h2>{selectedGroup ? 'Edit group' : 'Create group'}</h2>
            {selectedGroup ? <span>Group sending is disabled.</span> : null}
          </div>
          <label>
            Group name
            <input name="name" onChange={onUpdateForm} value={groupForm.name} />
          </label>
          <label>
            Description
            <input name="description" onChange={onUpdateForm} value={groupForm.description} />
          </label>
          <label>
            Paste emails
            <textarea
              name="emailsText"
              onChange={onUpdateForm}
              placeholder="candidate1@gmail.com&#10;Suman Kumar <suman@gmail.com>"
              rows="10"
              value={groupForm.emailsText}
            />
          </label>
          <div className="bulk-preview-grid">
            <span>Valid: {preview.validEmails.length}</span>
            <span>Invalid: {preview.invalidEmails.length}</span>
            <span>Duplicates removed: {preview.duplicateEmails.length}</span>
            <span>Saved: {selectedGroup?.emails?.length || 0}</span>
          </div>
          {preview.invalidEmails.length ? (
            <p className="admin-email-warning">Invalid: {preview.invalidEmails.join(', ')}</p>
          ) : null}
          <div className="admin-bulk-actions">
            <button className="btn btn--primary" disabled={submitting || !groupForm.name.trim()} type="submit">
              {selectedGroup ? 'Save Group' : 'Create Group'}
            </button>
            {selectedGroup ? (
              <button className="btn btn--secondary" onClick={() => onDelete(selectedGroup._id)} type="button">
                Delete Group
              </button>
            ) : null}
          </div>
        </form>

        {selectedGroup ? (
          <div className="admin-email-group-emails">
            <div className="admin-page__header--split">
              <h3>Saved emails</h3>
              <textarea readOnly rows="4" value={selectedEmailsText} />
            </div>
            {selectedGroup.emails?.map((record) => (
              <div className="admin-email-group-email-row" key={record._id}>
                <span>{record.email}</span>
                <span>{record.name || 'No name'}</span>
                <button onClick={() => onRemoveEmail(selectedGroup._id, record._id)} type="button">
                  Remove
                </button>
              </div>
            ))}
          </div>
        ) : null}
      </section>
    </div>
  );
}

export default EmailGroups;
